















































































































































































































































































































import Vue from "vue";
import { dateFormat } from "@/helpers";
import Confirm from "@/components/atoms/Confirm.vue";
import TableList from "@/components/atoms/TableList.vue";
import DigitChanger from "@/components/atoms/DigitChanger.vue";
import DropdownComponent from "@/components/atoms/DropdownComponent.vue";
import DateComponent from "@/components/atoms/DateComponent.vue";
import TextFieldComponent from "@/components/atoms/TextFieldComponent.vue";
import TextAreaComponent from "@/components/atoms/TextAreaComponent.vue";
import JustifiedList from "@/components/atoms/JustifiedList.vue";
import { mapState } from "vuex";
import { ContainerType } from "@/helpers";
import LoadingComponent from "@/components/atoms/LoadingComponent.vue";
import * as Sentry from "@sentry/browser";

const TestProps = {
  props: {
    agreement: Object,
    openOrderCount: Number,
    containerActions: Array,
    actionLabels: Array,
    buttonOutlined: Boolean
  }
};
export default Vue.extend({
  ...TestProps,
  ...{
    data: () => {
      return {
        isHinweisValid: true,
        isLoading: false,
        containerActionId: 0,
        order: {
          amount: 1,
          orderDate: "",
          desiredDate: "",
          hint: "",
          selectedInterval: "",
          selectedFirstDay: "",
          selectedSecondDay: "",
          customerSpecialOrderId: ""
        },
        desiredDateFormatted: "",
        datePickerDesired: false,
        today: "",
        dialog: false,
        componentKey: 0
      };
    },
    components: {
      Confirm,
      TableList,
      DigitChanger,
      DropdownComponent,
      DateComponent,
      TextFieldComponent,
      TextAreaComponent,
      JustifiedList,
      LoadingComponent
    },
    mounted() {
      this.today = new Date().toISOString().split("T")[0];
    },
    methods: {
      setOrderDate() {
        this.desiredDateFormatted = dateFormat(this.order.desiredDate);
        this.datePickerDesired = false;
      },
      validateForm() {
        if (
          // ugly because this.$refs.form.validate() is not typescript ready // missing declaration
          // @see https://stackoverflow.com/questions/52109471/typescript-in-vue-property-validate-does-not-exist-on-type-vue-element/52109899
          !(this.$refs.createForm as Vue & {
            validate: () => boolean;
          }).validate()
        ) {
          return;
        }
        this.dialog = true;
      },
      sendOrder() {
        this.isLoading = true;
        this.dialog = false;
        if (this.agreement.agreementTypeId === 4) {
          this.order.selectedInterval = this.agreement.selectedInterval;
          this.order.selectedFirstDay = this.agreement.selectedFirstDay;
          this.order.selectedSecondDay = this.agreement.selectedSecondDay;
        }
        const payload = {
          agreementId: this.$props.agreement.id,
          containerActionId: this.containerActionId,
          ...this.$data.order
        };
        payload.orderDate = new Date().toISOString();

        let allowOrderCreation = false;
        if (
          this.company.connectToMynature &&
          !this.agreement.externalSystemId
        ) {
          this.$store
            .dispatch("getLocationDetail", this.company.locationDetail.id)
            .then(res => {
              for(const agreement of res.data.agreements) {
                if(agreement.id === this.agreement.id && agreement.externalSystemId) {
                  allowOrderCreation = true;
                  break;
                }
              }
              if (
                res.data.company.connectToMynature &&
                !allowOrderCreation
              ) {
                this.isLoading = false;
                this.$toast.error(
                  "Ups! Konnte keine Auftrag erstellen. Bitte versuchen Sie es erneut!", { timeout: 5000 });
                Sentry.captureException(new Error(
                  `Ups! Konnte keine Vereinbarung erstellen. Bitte versuchen Sie es erneut!\n Agreement ID: ${this.agreement.id}`));
              } else {
                this.$store
                  .dispatch("createOrder", payload)
                  .then(_ => {
                    this.$toast("Der Auftrag wurde übermittelt. Vielen Dank.", {
                      timeout: 4000
                    });
                    if (this.$cookies.isAccepted()){
                      (this as any).$gtag.event("order-create", {
                        'event_category': "order",
                        'event_label': this.agreement.wasteType.description,
                        value: this.containerActionId
                      });
                    }
                    this.resetAll();
                  })
                  .catch(e => {
                    if (e.response)
                      this.$toast.error(e.response.data.error.message);
                    Sentry.captureException(e);
                    this.resetAll();
                  });
              }
            });
        } else {
          this.$store
            .dispatch("createOrder", payload)
            .then(_ => {
              this.$toast("Der Auftrag wurde übermittelt. Vielen Dank.", {
                timeout: 4000
              });
              if (this.$cookies.isAccepted()){
                (this as any).$gtag.event("order-create", {
                  'event_category': "order",
                  'event_label': this.agreement.wasteType.description,
                  value: this.containerActionId
                });
              }
              this.resetAll();
            })
            .catch(e => {
              if (e.response) this.$toast.error(e.response.data.error.message);
              Sentry.captureException(e);
              this.resetAll();
            });
        }
        // this.sendCreateRequest()
      },
      setNextBusinessDay(offset = 1): void {
        const date = new Date();
        do {
          date.setDate(date.getDate() + offset);
        } while (!(date.getDay() % 6));
        //return date;
        this.$data.order.desiredDate = date.toISOString().split("T")[0];
      },
      allowedDates: (val: any) => new Date(val).getDay() % 6,
      getTomorrow() {
        const today = new Date();
        today.setDate(today.getDate() + 1);
        return today.toISOString();
      },
      ucfirst(str: string) {
        return str.replace(/^./, str[0].toUpperCase());
      },
      setOrderAmount: function(amountValue: number) {
        this.order.amount = amountValue;
      },
      setActionValue: function(actionValue: any) {
        this.containerActionId = actionValue;
      },
      setOrderDateFromComponent: function(dateValue: string) {
        this.order.desiredDate = dateValue;
        this.desiredDateFormatted = dateFormat(this.order.desiredDate);
      },
      setSpecialOrderId: function(specialOrderId: any) {
        this.order.customerSpecialOrderId = specialOrderId;
      },
      setHintValue: function(hintValue: string) {
        this.order.hint = hintValue;
      },
      resetAll() {
        this.componentKey += 1;
        this.$emit("close-beauftragen-dialog");
        this.isLoading = false;
      }
    },
    computed: {
      ...mapState({
        company: (state: any) => state.company,
        hasAgreementNr: (state: any) => state.company.hasAgreementNr,
        hasOrderNr: (state: any) => state.company.hasOrderNr
      }),
      amountLabel() {
        if (this.agreement.containerType.type === "Lose Abholung") {
          return "Kubikmeter";
        }
        if (
          this.agreement.containerType.type === "Big Bag" ||
          this.agreement.containerType.type === "Sammelsack"
        ) {
          return "Stück";
        }
        return "Anzahl";
      },
      amountMax() {
        if (
          this.$props.agreement.containerType.type === "Big Bag" ||
          this.$props.agreement.containerType.type === "Sammelsack" ||
          this.$props.agreement.containerType.type === "Lose Abholung"
        ) {
          return 10;
        }
        return this.$props.agreement.amount - this.$props.openOrderCount;
      },
      locationName() {
        return this.$store.getters.location.displayName;
      },
      isMobile() {
        return this.$vuetify.breakpoint.width < 768;
      },
      isSmallDevice() {
        return this.$vuetify.breakpoint.width < 325;
      },
      containerInfoHeader() {
        const containerTypeExtra = this.$props.agreement.containerType.extra
          ? String.prototype.concat(" ",this.$props.agreement.containerType.extra) : "";
        if (this.agreement.containerTypeId === ContainerType.LOSE_ABHOLUNG) {
          return `${this.$props.agreement.containerType.type} ${this.$props
            .agreement.containerType.extra || ""}`;
        } else if (
          ContainerType.SAMMELSACK.includes(this.agreement.containerTypeId) ||
          ContainerType.BIGBAG.includes(this.agreement.containerTypeId)
        ) {
          return String.prototype.concat(
            this.$props.agreement.containerType.type,
            containerTypeExtra,
            ", ",
            this.$props.agreement.containerType.size || ""
          );
        }
        return String.prototype.concat(
          this.$props.agreement.amount,
          "x",
          " ",
          this.$props.agreement.containerType.type,
          containerTypeExtra,
          ", ",
          this.$props.agreement.containerType.size || ""
        );
      }
    }
  }
});
